import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    .init({
        debug: Boolean(import.meta.env?.DEV),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    common: {
                        loading: "Loading...",
                        error: "An error occurred",
                        print: "Print",
                        share: "Share",
                        recordLocator: "Record Locator",
                        paymentRequired: "Payment Required"
                    },
                    nav: {
                        itinerary: "Itinerary",
                        documents: "Documents",
                        flightStatus: "Flight Status"
                    },
                    status: {
                        confirmed: "Confirmed",
                        delayed: "Delayed",
                        cancelled: "Cancelled"
                    }
                }
            },
            es: {
                translation: {
                    common: {
                        loading: "Cargando...",
                        error: "Ocurrió un error",
                        print: "Imprimir",
                        share: "Compartir",
                        recordLocator: "Localizador",
                        paymentRequired: "Pago Requerido"
                    },
                    nav: {
                        itinerary: "Itinerario",
                        documents: "Documentos",
                        flightStatus: "Estado del Vuelo"
                    },
                    status: {
                        confirmed: "Confirmado",
                        delayed: "Retrasado",
                        cancelled: "Cancelado"
                    }
                }
            },
            fr: {
                translation: {
                    common: {
                        loading: "Chargement...",
                        error: "Une erreur est survenue",
                        print: "Imprimer",
                        share: "Partager",
                        recordLocator: "Référence Dossier",
                        paymentRequired: "Paiement Requis"
                    },
                    nav: {
                        itinerary: "Itinéraire",
                        documents: "Documents",
                        flightStatus: "Statut du Vol"
                    },
                    status: {
                        confirmed: "Confirmé",
                        delayed: "Retardé",
                        cancelled: "Annulé"
                    }
                }
            }
        }
    });

export default i18n;
